var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfrastructureEquipmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5580",
    "data-name": "Group 5580",
    transform: "translate(-9823.5 -2937.082)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(9823.5 2937.082)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764",
    transform: "translate(9756.75 2941.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M341.25,218.75h1.129v10.161H341.25Z",
    transform: "translate(-245.565 -196.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M480.968,160.6V150.444h.565V148.75H472.5v1.694h.565V160.6h2.258v-2.823h3.387V160.6Zm-3.387-9.032h1.694v1.694h-1.694Zm-1.129,4.516h-1.694V154.4h1.694Zm0-2.823h-1.694v-1.694h1.694Zm1.129,2.823V154.4h1.694v1.694Z",
    transform: "translate(-368.347 -130.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M280,10.444h.565V20.6h2.258V17.782h3.387V20.6h2.258V10.444h.565V8.75H280Zm5.081,1.129h1.694v1.694h-1.694Zm0,2.823h1.694v1.694h-1.694Zm-2.823-2.823h1.694v1.694h-1.694Zm0,2.823h1.694v1.694h-1.694Z",
    transform: "translate(-188.266 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M95.968,169.355V159.194h.565V157.5H87.5v1.694h.565v10.161h2.258v-2.823H93.71v2.823Zm-3.387-9.032h1.694v1.694H92.581Zm-1.129,4.516H89.758v-1.694h1.694Zm0-2.823H89.758v-1.694h1.694Zm1.129,2.823v-1.694h1.694v1.694Z",
    transform: "translate(-8.185 -139.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M289.032,401.653v-5.645c0-1.482-2.272-2.258-4.516-2.258s-4.516.776-4.516,2.258v5.645c0,1.482,2.272,2.258,4.516,2.258S289.032,403.136,289.032,401.653Zm-1.129-1.289a8.277,8.277,0,0,1-6.774,0v-1.533c0,.4,1.286,1.129,3.387,1.129s3.387-.734,3.387-1.129Zm-3.387-3.227c-2.1,0-3.387-.734-3.387-1.129s1.286-1.129,3.387-1.129,3.387.734,3.387,1.129S286.617,397.137,284.516,397.137Z",
    transform: "translate(-188.266 -360.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M444.839,364.2v-5.455H443.71V364.2a1.971,1.971,0,0,0-1.319,1.319H437.5v1.129h4.89a1.963,1.963,0,0,0,3.768,0h3.2v-1.129h-3.2a1.971,1.971,0,0,0-1.319-1.319Zm-.565,2.731a.847.847,0,1,1,.847-.847.847.847,0,0,1-.847.847Z",
    transform: "translate(-335.605 -327.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M83.831,368.059a1.973,1.973,0,0,0,1.884-1.411H90.6v-1.129h-4.89A1.972,1.972,0,0,0,84.4,364.2v-5.455H83.266V364.2a1.972,1.972,0,0,0-1.319,1.319h-3.2v1.129h3.2a1.973,1.973,0,0,0,1.884,1.411Zm0-2.823a.847.847,0,1,1-.847.847.847.847,0,0,1,.847-.847Z",
    transform: "translate(0 -327.414)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructureEquipmentIcon);
export default __webpack_public_path__ + "static/media/infrastructure-equipment-icon.428bb37d.svg";
export { ForwardRef as ReactComponent };